import * as constants from '../constants';
import converter from '../converter';

const initialState = false;

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getCalculatorsMordoviaShape.try: {
            return false;
        }

        case constants.getCalculatorsMordoviaShape.success:
        case constants.getCalculatorsMordoviaShape.error: {
            return true;
        }

        default:
            return state;
    }
}
